import React from "react";
import { BaseReportLayoutLeft } from "features/BaseReportLayoutLeft/BaseReportLayoutLeft";
import { ReportTable } from "features/Reports/ReportTable";

import { ReportContainerLeft } from "components/ReportContainer/ReportContainerLeft";
import { ReportContainerRight } from "components/ReportContainer/ReportContainerRight";

export const ProfitReportPage = (): JSX.Element => (
  <>
    <ReportContainerLeft>
      <BaseReportLayoutLeft title="Товары" isMultiStore type="profit" />
    </ReportContainerLeft>
    <ReportContainerRight>
      <ReportTable title="Отчёт по прибыли (по сети магазинов)" type="profit" />
    </ReportContainerRight>
  </>
);
